/**
 * 天地图 JS API 4.0 加载器
 *
 * 全局只插入一次 <script>，所有组件（MapSelect、OrderDea 等）共用同一个 tk
 * 和同一个加载 Promise，避免重复请求、也避免 tk 散落在各处。
 *
 * 注意：这个 tk 是「浏览器端」类型，必须去天地图控制台把实际访问的域名
 * 加进「授权域名」白名单，否则地图会加载失败（控制台可见 tk 相关报错）。
 */
export const TIANDITU_TK = '63a3b1b1cc288652ab08ae0d8f606894'

const SCRIPT_ID = 'tianditu-js-api'
const API_VERSION = '4.0'
const LOAD_TIMEOUT = 15000
const POLL_INTERVAL = 100

// 加载中的 Promise，防止并发重复插入 script
let loadingPromise = null

export function loadTianditu() {
	if (window.T && window.T.Map) {
		return Promise.resolve(window.T)
	}
	if (loadingPromise) {
		return loadingPromise
	}

	loadingPromise = new Promise((resolve, reject) => {
		// script.onload 之后 T 还可能是异步就绪的，轮询等它挂到 window 上
		const waitForT = () => {
			let waited = 0
			const timer = setInterval(() => {
				if (window.T && window.T.Map) {
					clearInterval(timer)
					resolve(window.T)
				} else if ((waited += POLL_INTERVAL) > LOAD_TIMEOUT) {
					clearInterval(timer)
					loadingPromise = null
					reject(new Error('天地图 API 初始化超时，请检查网络'))
				}
			}, POLL_INTERVAL)
		}

		// 页面上已经有这个 script 了（比如别的组件先加载的），直接等 T
		if (document.getElementById(SCRIPT_ID)) {
			waitForT()
			return
		}

		const script = document.createElement('script')
		script.id = SCRIPT_ID
		script.type = 'text/javascript'
		script.src = `https://api.tianditu.gov.cn/api?v=${API_VERSION}&tk=${TIANDITU_TK}`
		script.onload = waitForT
		script.onerror = () => {
			loadingPromise = null
			reject(new Error('天地图脚本加载失败：请检查 tk 是否有效、域名白名单是否包含当前域名'))
		}
		document.head.appendChild(script)
	})

	return loadingPromise
}
